@if (navigationPending()) {
  <div class="route-progress" role="status" aria-live="polite">
    <span class="visually-hidden">Loading page</span>
  </div>
}

<router-outlet />
